import React from "react"
import Arrow from "../../../../../../assets/images/Inner/arrow.svg";
import Line from "../../../../../../assets/images/dashboard/line.svg";
import { getNotesFromLuci } from "../../../../../../utils/constants"

import Plus from "../../../../../../assets/images/dashboard/plus.svg";
import Minus from "../../../../../../assets/images/dashboard/minus.svg";
import Equal from "../../../../../../assets/images/dashboard/equal.svg";

// for CardDetailsByGraph
import CardDetailsByGraph from "../component/CardDetailsByGraph"
import {
    getFeaturesIcon, 
    getToolTipConstant,
    valueWithCommas,
    commaSeparator,
    firstYear,
    secondYear,
    lastYear,
} from "../../../../../../utils/constants"
import Rate from "../../../../../../assets/images/dashboard/rate.svg";
import Prize from "../../../../../../assets/images/dashboard/prize.svg";
import { Tooltip, Divider } from "antd";
import Help from "../../../../../../assets/images/dashboard/help-icon.svg";
const getOtherRewards = (otherObject) => {
    try {
        return JSON.parse(otherObject) || {}
    } catch (e) {
        return {}
    }
}



function SeeMoreDetailsRewards(args) {
    
    const {
        card,
        updateCarouselHeight,
        topIncludedIntroBonus,
        cardDetailsByGraphObj = {},
    } = args;
    
    const {
        moreDetailInfo,
        moreDetailNotes,
        rewardDetail,
        calculation,
        points,
        annualFee = "",
        annualFeeDetail = [],
        introMoney,
        introPoints,
        unitForPoints = "",
        introOfferDetail = [],
        totalMoney,
        totalMoneyPerYear,
    } = card;
    
    //
    const { isReward, isIntro, isAnnual } = calculation || {};
    
    // 
    const {
        stat, money, avgSpending, spending, onGetDate, selectedDate, topYearProjection,
        rewardInfoLong, features, otherRewards, annualFeeDisplay, annualFeeGeneralDetail, 
        creditRange, rewardRate, rewardRateGeneralDetail, introOffer, introOfferGeneralDetail,
    } = cardDetailsByGraphObj;
    
    // states
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [isVisible, setIsVisible] = React.useState(false);
    const [isFadeIn, setIsFadeIn] = React.useState(false);
    
    // trigger update carousel height
    const isExpandComplete = isExpanded && isVisible && isFadeIn;
    const prevIsExpandComplete = React.useRef(false);
    if (prevIsExpandComplete.current != isExpandComplete && updateCarouselHeight) {
        prevIsExpandComplete.current = isExpandComplete;
        updateCarouselHeight();
    }
    const isShrinkComplete = !isExpanded && !isVisible && !isFadeIn;
    const prevIsShrinkComplete = React.useRef(true); // initially shrunk
    if (prevIsShrinkComplete.current != isShrinkComplete && updateCarouselHeight) {
        prevIsShrinkComplete.current = isShrinkComplete;
        updateCarouselHeight();
    }
    
    // calc
    const returnPerc = Math.round(totalMoney/spending*10000) / 100;
    
    // do expand animation first, then show the expanded contents
    React.useEffect(() => {
        if (isExpanded) {
            // expand parent, then show child with delay
            const timeout = setTimeout(() => {
                setIsVisible(true);
                setTimeout(() => setIsFadeIn(true), 10);
            }, 10);
            return () => clearTimeout(timeout);
        } else {
            const timeout = setTimeout(() => {
                setIsVisible(false);
                setIsFadeIn(false);
            }, 10);
            return () => clearTimeout(timeout);
        }
    }, [isExpanded]);
    
    // 
    return (
        
        <div className={"card-carousel-expandable" + (isExpanded? " expanded" : "")}>
            
            {/* toggle */}
            <div
                className="card-carousel-expandable-toggle ga-ccAddlDetails ga-ccAddlDetails-rewards"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div>
                    Luci Total Rewards
                    {isExpanded && topYearProjection && topYearProjection != firstYear()? 
                        <span className="gray-subtext">
                            {" (" + topYearProjection + " year projection)"}
                        </span>
                        : null
                    }
                </div>
                <div>
                    {isExpanded?
                        <img src={Arrow} className=""/>
                        :
                        <img src={Arrow} className="" style={{transform: "rotate(180deg)"}}/>
                    }
                </div>
            </div>
            
            <div className={"card-carousel-expanded" + (isFadeIn? "" : " fading-in")} style={{display: isVisible? null : "none"}}>
            
                {/* math */}
                <div className="card-carousel-math">
                    
                    {/* rewards from trx */}
                    <div className="card-carousel-math-element">
                        <div className="card-carousel-math-label">
                            Reward Value
                        </div>
                        <div className="card-carousel-math-value">
                            <div className="dollar-value">
                                ${valueWithCommas(money || 0)}
                                { !!(rewardDetail || []).length &&
                                    <Tooltip
                                        title={getToolTipConstant(rewardDetail || [])}
                                        trigger={["hover", "click"]}
                                    >
                                        <img className="gray-help" src={Help}/>
                                    </Tooltip>
                                }
                            </div>
                            { !!points && 
                                <div className="sub-value">
                                    {`(${commaSeparator(points || 0)} Points)`}
                                </div>
                            }
                            <div className="card-carousel-return-value">
                                {returnPerc}% of total spending
                            </div>
                        </div>
                    </div>
                    
                    {/* plus intro bonus */}
                    {topIncludedIntroBonus?
                        <div className="card-carousel-math-group">
                            <div className="card-carousel-math-symbol">
                                <img src={Plus} style={(!isReward || !isIntro) ? {opacity: '0.5'} : null}/>
                            </div>
                            <div className="card-carousel-math-element">
                                <div className="card-carousel-math-label">
                                    Intro Bonus
                                </div>
                                <div className="card-carousel-math-value">
                                    <div className={"dollar-value " + (!isIntro ? "color-gray" : "")}>
                                        ${valueWithCommas(introMoney || 0)}
                                        { !!(introOfferDetail || []).length &&
                                            <Tooltip
                                                title={getToolTipConstant(introOfferDetail || [])}
                                                trigger={["hover", "click"]}
                                            >
                                                <img className="gray-help" src={Help} style={!isIntro ? {opacity: '0.5'} : null}/>
                                            </Tooltip>
                                        }
                                    </div>
                                    <div className="sub-value">
                                        { (introPoints || unitForPoints) ?
                                            <div className={!isIntro ? "color-gray" : ""}>
                                                {`(${commaSeparator(introPoints || 0)} ${unitForPoints})`}
                                            </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    
                    {/* minus annual fee */}
                    <div className="card-carousel-math-group">
                        <div className="card-carousel-math-symbol">
                            <img src={Minus} style={!isAnnual ? {opacity: '0.5'} : null}/>
                        </div>
                        <div className="card-carousel-math-element">
                            <div className="card-carousel-math-label">
                                Annual Fee
                            </div>
                            <div className="card-carousel-math-value">
                                <div className="dollar-value">
                                    ${annualFee}
                                    { !!(annualFeeDetail || []).length &&
                                        <Tooltip
                                            title={getToolTipConstant(annualFeeDetail || [])}
                                            trigger={["hover", "click"]}
                                        >
                                            <img className="gray-help" src={Help} style={!isAnnual ? {opacity: '0.5'} : null}/>
                                        </Tooltip>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* equal */}
                    <div className="card-carousel-math-group">
                        <div className="card-carousel-math-symbol">
                            <img src={Equal}/>
                        </div>
                        <div className="card-carousel-math-element">
                            <div className="card-carousel-math-label">
                                Total Reward
                            </div>
                            <div className="card-carousel-math-value total-reward-value">
                                <div className="dollar-value">
                                    <div>${valueWithCommas(totalMoney || 0)}</div>
                                    { topYearProjection !== firstYear() ?
                                        <div className="dollar-value-per-year">
                                            {`($${valueWithCommas(totalMoneyPerYear || 0)}/year)`}
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <Divider style={{marginTop: 20, marginBottom: 20}}/>
                
                {/* reward breakdown (not yet implemented) */}
                {/*
                <div className="card-carousel-reward-breakdown">
                </div>
                */}
                
                {/*  */}
                <div className="card-carousel-graph">
                    <CardDetailsByGraph
                      stat={stat || []}
                      money={money}
                      avgSpending={avgSpending}
                      spending={spending}
                      onGetDate={onGetDate}
                      selectedDate={selectedDate}
                      topYearProjection={topYearProjection}
                    />
                </div>
                
            </div>
        </div>
    );
    
}


export default SeeMoreDetailsRewards
